import React, { useState } from "react"
import PropTypes from "prop-types"
import { 
  Card,
  Row,
  Button,
  ModalBody,
  ModalFooter,
  Form,
  Col,
  Input,
  Label
} from "reactstrap"
import i18n from "../../../i18n"
import * as Yup from 'yup';
import { useFormik } from "formik";

import "flatpickr/dist/themes/material_blue.css";
import { useDispatch } from "react-redux";

const Step2 = (props) => {

  const { setStep, setSelectRouting, selectRouting, setNewAddress, setNewDestination  } = props;

  const autoformik = useFormik({
    initialValues: {
      startingPoint: "",
      destination: ""
    },
    validationSchema: Yup.object({
      startingPoint: Yup.string(),
      destination: Yup.string()
    })
  });

  const dispatch = useDispatch();
  const [errorAlert, setErrorAlert] = useState(false);

  const next = () => {
    setStep(3);
    setNewAddress(autoformik.values.startingPoint)
    setNewDestination(autoformik.values.destination)
  }

  const onClicklBack = () => {
    setStep(1);
    setSelectRouting(null);
  }

  return (
    <Card>
      <ModalBody>
        <h5 className="">{i18n.t("ModifyAddresses")}</h5>
        <Row>
          <div className="col-6 text-start">
            <a className="btn btn-danger btn-small btn-rounded fs-8">1</a>
          </div>
          <div className="col-6 text-end">
            <a className="btn btn-light btn-small btn-rounded fs-8">2</a>
          </div>
        </Row>

        <Col className="mt-3" xs={12} xl={12}>
          <p className="">{i18n.t("CurrentAddresses")}</p>
          <p className="">{`${i18n.t("StartingPoint")}: ${selectRouting.startingPoint}`}</p>
          <p className="">{`${i18n.t("Destination")}: ${selectRouting.destination}`}</p>
        </Col>

        <Col className="mt-3" xs={12} xl={12}>
          <p className="">{i18n.t("NewAddresses")}</p>
        </Col>

        <Form className="row gy-2 gx-3 align-items-center" onSubmit={autoformik.handleSubmit}>
          <Col xxl={12} md={12} xs={12}>
            <div className="col-sm-auto">
              <Label className="visually" htmlFor="startingPointInput">{i18n.t("StartingPoint")}</Label>                     
              <Input type="text" name="startingPoint" className="form-control" id="startingPointInput" placeholder={i18n.t("StartingPoint")}
                value={autoformik.values.startingPoint}
                onChange={autoformik.handleChange}
                onBlur={autoformik.handleBlur}
                invalid={
                  autoformik.touched.startingPoint && autoformik.errors.startingPoint ? true : false
                } />
              {
                autoformik.errors.startingPoint && autoformik.touched.startingPoint ? (
                  <FormFeedback type="invalid">{autoformik.errors.startingPoint}</FormFeedback>
                ) : null
              }
            </div>
          </Col>

          <Col xxl={12} md={12} xs={12}>
            <div className="col-sm-auto">
              <Label className="visually" htmlFor="destinationInput">{i18n.t("Destination")}</Label>                
              <Input type="text" name="destination" className="form-control" id="destinationInput" placeholder={i18n.t("Destination")}
                value={autoformik.values.destination}
                onChange={autoformik.handleChange}
                onBlur={autoformik.handleBlur}
                invalid={
                  autoformik.touched.destination && autoformik.errors.destination ? true : false
                } />
              {
                autoformik.errors.destination && autoformik.touched.destination ? (
                  <FormFeedback type="invalid">{autoformik.errors.destination}</FormFeedback>
                ) : null
              }
            </div>
          </Col>
        </Form>

      </ModalBody>
      <ModalFooter>
        <Button className="btn-danger" type="button" color="secondary" onClick={next}>
          {i18n.t("Continue")}
        </Button>
        <Button
          className="btn-light"
          type="button"
          color="secondary"
          data-dismiss="modal"
          onClick={onClicklBack}
        >
          {i18n.t("Back")}
        </Button>
      </ModalFooter>
    </Card>
  )
}

Step2.propTypes = {
  setStep: PropTypes.func,
  setSelectRouting: PropTypes.func,
  setNewAddress: PropTypes.func,
  setNewDestination: PropTypes.func,
  selectRouting: PropTypes.object
}

export default Step2;
